import { useEffect, useState } from 'react';
import { useAuthStore } from '../stores/authStore';
import { api } from '../services/api';
import { LayoutDashboard, BookOpen, Layers, FileQuestion, Share2, Loader2 } from 'lucide-react';

interface Stats {
  topics: number;
  words: number;
  quizzes: number;
  published: number;
}

export default function DashboardPage() {
  const { user } = useAuthStore();
  const [stats, setStats] = useState<Stats | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await api.get('/topics/stats');
        setStats(res.data.data);
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, []);

  const statCards = [
    { label: 'Тем', value: stats?.topics ?? 0, icon: Layers },
    { label: 'Слов', value: stats?.words ?? 0, icon: BookOpen },
    { label: 'Тестов', value: stats?.quizzes ?? 0, icon: FileQuestion },
    { label: 'Опубликовано', value: stats?.published ?? 0, icon: Share2 },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">
          Добро пожаловать, {user?.name}!
        </h1>
        <p className="mt-1 text-sm text-gray-500">
          Управляйте темами, словами и тестами для изучения турецкого языка.
        </p>
      </div>

      {loading ? (
        <div className="flex h-32 items-center justify-center">
          <Loader2 className="h-8 w-8 animate-spin text-brand-600" />
        </div>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {statCards.map((stat) => (
            <div
              key={stat.label}
              className="flex items-center rounded-xl border border-gray-100 bg-white p-4 shadow-sm"
            >
              <div className="mr-4 flex h-10 w-10 items-center justify-center rounded-lg bg-brand-50 text-brand-600">
                <stat.icon size={20} />
              </div>
              <div>
                <div className="text-2xl font-bold text-gray-900">{stat.value}</div>
                <div className="text-xs text-gray-500">{stat.label}</div>
              </div>
            </div>
          ))}
        </div>
      )}

      <div className="rounded-xl border border-gray-100 bg-white p-6 shadow-sm">
        <div className="flex items-center gap-2">
          <LayoutDashboard size={20} className="text-brand-600" />
          <h2 className="text-lg font-semibold text-gray-900">Быстрые действия</h2>
        </div>
        <div className="mt-4 flex flex-wrap gap-3">
          <a
            href="/topics"
            className="rounded-lg bg-brand-600 px-4 py-2 text-sm font-medium text-white hover:bg-brand-700"
          >
            Создать тему
          </a>
        </div>
      </div>
    </div>
  );
}
